/**
 * TanStack Query client configuration.
 *
 * Defaults:
 *   - `retry: false` — we don't want silent retry loops on transient
 *     network errors; pages should surface errors explicitly to the user.
 *     Individual queries can opt back into retry if they need it.
 *   - `refetchOnWindowFocus: false` — refetching on window focus is nice
 *     for dashboards but noisy during development. We can flip it on
 *     for specific queries (like `/me`) once the app is in real use.
 *   - `staleTime: 30s` — enough to avoid hammering the API on tab
 *     switches, short enough that admin actions feel live.
 */

import { QueryClient } from "@tanstack/react-query";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
